import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "./api";

/**
 * Nome do produto (PRODUTO_NOME no servidor), igual para todas as clínicas: aparece na entrada e no título da aba.
 * Enquanto não chega, a tela usa o título que já está no index.html.
 */
export const consultaProduto = queryOptions({
  queryKey: ["saude", "produto"],
  queryFn: async () => {
    const r = await api<{ produto?: string }>("/saude");
    return r.produto || document.title;
  },
  staleTime: Infinity,
  gcTime: Infinity,
});

export function useProduto() {
  return useQuery(consultaProduto).data ?? "";
}
